import Vue from "vue";
import ConfirmModal from "./confirm-modal.vue";
const Modal = {};
Modal.newInstance = properties => {
  const _props = properties || { title: "test", width: 400, onCancel: () => {} };

  const ComponentClass = Vue.extend(ConfirmModal);
  const Instance = new ComponentClass({
    propsData: _props
  });

  const component = Instance.$mount();
  document.body.appendChild(component.$el);
  const modal = Instance.$children[0];

  return {
    show(props) {
      modal.$parent.showCancel = props.showCancel;
      modal.$parent.iconType = props.icon;

      if ("width" in props) {
        modal.$parent.width = props.width;
      } else {
        modal.$parent.width = 400;
      }

      if ("closable" in props) {
        modal.$parent.closable = props.closable;
      }

      if ("title" in props) {
        modal.$parent.title = props.title;
      }

      if ("content" in props) {
        modal.$parent.body = props.content;
      }

      if ("okText" in props) {
        modal.$parent.okText = props.okText;
      }

      if ("cancelText" in props) {
        modal.$parent.cancelText = props.cancelText;
      }

      if ("onCancel" in props) {
        modal.$parent.onCancel = props.onCancel;
      }

      if ("onOk" in props) {
        modal.$parent.onOk = props.onOk;
      }

      // async for ok
      if ("loading" in props) {
        modal.$parent.loading = props.loading;
      }

      if ("scrollable" in props) {
        modal.$parent.scrollable = props.scrollable;
      }

      modal.$parent.$on("cancel", () => {
        modal.$parent.show = false;
      });

      modal.$parent.$on("ok", () => {
        modal.$parent.show = false;
      });

      modal.$parent.show = true;
    },
    remove() {
      modal.$parent.show = false;
      modal.$parent.buttonLoading = false;
    },
    component: modal
  };
};

let modalInstance;

function getModalInstance(render = undefined) {
  modalInstance =
    modalInstance ||
    Modal.newInstance({
      closable: false,
      maskClosable: false,
      footerHide: true,
      render: render
    });

  return modalInstance;
}

function confirm(options) {
  const render = "render" in options ? options.render : undefined;
  let instance = getModalInstance(render);

  options.onRemove = function() {
    modalInstance = null;
  };

  instance.show(options);
}

Modal.confirm = function(props = {}) {
  props.icon = "confirm";
  props.showCancel = true;
  return confirm(props);
};

export default Modal;
